/**
 * @typedef {Object} CustomMessage
 * @property {number} status Status code of the response
 * @property {string} title The custom title to use
 * @property {string} message A custom message to use
 */

let showMessageGlobal = null;
let logoutGlobal = null;

/**
 * Einmaliges Registrieren des showMessage Objekts zum Anzeigen von Messages in allen Komponenten der Anwendung.
 * @param {*} fn 
 */
export function registerShowMessage(fn) {
    showMessageGlobal = fn;
}

/**
 * Einmaliges Registrieren der globalen Logout-Funktion.
 * @param {*} fn 
 */
 export function registerLogout(fn) {
    logoutGlobal = fn;
}

/**
 * Create a message object based on a Superagent Response Error object.
 * @param {*} responseError Optionally, the error object returned from the server.
 * @param {Array<CustomMessage>} customMessage Optional, a list of custom messages.
 */
 export function handleResponseError(responseError, customMessages) {
    if (!showMessageGlobal) {
        console.error("Die Funktion showMessage ist nicht registriert, Meldungen können noch nicht ausgegeben werden.");
        return;
    }

    // Der Fehler tritt normalerweise auf, wenn etwas im Code selbst fehlschlägt
    if (!responseError?.response) {
        showMessageGlobal("Allgemeiner Fehler beim Errorhandling");
        return
    }

    handleStatusCode(responseError.response.status, customMessages)
 }

/**
 * Handles an error message based on a status code.
 * @param {number} statusCode The status code of the response.
 * @param {Array<CustomMessage>} customMessage Optional, a list of custom messages.
 */
export function handleStatusCode(statusCode, customMessages) {

    // A 401 indicates an invalid/expired token and will lead to a systematic logout
    if (statusCode === 401 && logoutGlobal) {
        logoutGlobal(); 
        showMessageGlobal("Sitzung abgelaufen", "Ihre Sitzung ist abgelaufen. Loggen Sie sich bitte erneut ein.", "warning")
        return;
    }

    const defaultMessages = [
        {
            status: 401,   // Backup in case that logoutGlobal is not defined yet
            title: "Unauthorized",
            message: "Sie sind nicht angemeldet. Bitte loggen sie sich ein, um fortzufahren."
        },
        {
            status: 403,
            title: "Forbidden",
            message: "Sie haben keine Berechtigung für diese Aktion."
        },
        {
            status: 404,
            title: "Not found",
            message: "Die angeforderte URL ist nicht vorhanden."
        },
        {
            status: 409,
            title: "Conflict",
            message: "Die Anfrage existiert bereits."
        },
        {
            status: 422,
            title: "Unprocessable entity",
            message: "Der Server kann die Anfrage nicht verarbeiten, da sie fehlerhaft ist."
        },
        {
            status: 500,
            title: "Internal server error",
            message: "Allgemeiner Serverfehler."
        },
    ]

    const defaultMessage = defaultMessages.find(defaultError => defaultError.status === statusCode)

    // First check whether there is a custom message for the given status code
    if(customMessages) {
        const customMessage = customMessages.find(customMessage => customMessage.status === statusCode)

        if(customMessage) {
            // Custom message exists. If there is no title/message, try to use the one from the default values.
            let {title, message} = customMessage

            if((title && message) || !defaultMessage) {
                showMessageGlobal(title, message)
            } else {
                showMessageGlobal(title ?? defaultMessage.title, message ?? defaultMessage.message)
            }
        }
    } else {
        if(defaultMessage) {
            showMessageGlobal(defaultMessage.title, defaultMessage.message)
        } else {
            showMessageGlobal(null, "Allgemeiner Fehler")
        }
    }

}

/**
 * General function to handle form validation errors.
 * @param {string} reason Optionally a reason why the form is not valid 
 */
export function handleFormError(reason) {
    if (!showMessageGlobal) {
        console.error("Die Funktion showMessage ist nicht registriert, Meldungen können noch nicht ausgegeben werden.");
        return;
    }
    
    showMessageGlobal("Formular-Fehler", reason ? reason : "Allgemeiner Fehler")
}